(ns frontend.components.inputs.related-entities
  (:require
   [clojure.string :as string]
   [frontend.components.inputs.footprint :refer [display-string editor viewer]]
   [frontend.components.inputs.select :as single-select]
   [frontend.components.open-search-select :as open-search-select]
   [reagent.core :as r]
   [reagent.impl.component :as reagent-component]))

(defmethod editor :editor.type/related-entities
  [args]
  (let [dom-atom (r/atom nil)
        key-atom (r/atom (str (gensym "select-component")))
        use-ref-selector? (some #{(:field/data-type args)}
                                [:data.type/ref-multi :data.type/ref-single])
        set-focusable! (:set-focusable-element! args)
        set-cancel-edit! (:set-cancel-edit! args)
        set-save! (:set-save! args)]                                                                ;; when do we reset the state ?
    ;; ref vs atom
    (r/create-class
     {:display-name           "Related-select"
      :component-did-mount    (fn [args]
                                (let []
                                  (when set-focusable!
                                    (set-focusable! (fn [_]
                                                      (when-let [dom-node (:input-dom-node @dom-atom)]
                                                        (.focus dom-node)))))
                                  (when set-cancel-edit!
                                    (set-cancel-edit! (fn [_]
                                                        (swap! dom-atom dissoc :temp-value))))      ;; save complete -> reset temp state
                                  (when set-save!
                                    (set-save! (fn [_]
                                                 (when-let [dom-node (:input-dom-node @dom-atom)]
                                                   (.blur dom-node)))))))
      :component-did-update   (fn [this old-argv]
                                (let [;;remounting if these props change - update list as needed:
                                      remount-props [:options :field/entity-types :entity/type
                                                     :value]
                                      prev-values (-> old-argv
                                                      reagent-component/extract-props
                                                      (select-keys remount-props))
                                      new-values (-> this
                                                     r/props
                                                     (select-keys remount-props))]
                                  (when-not (= prev-values new-values)
                                    ;;force remount
                                    (reset! key-atom (str (gensym "related-entities-component"))))))
      :component-will-unmount (fn []
                                (swap! dom-atom dissoc :input-dom-node))
      :reagent-render         (fn [args]
                                (if use-ref-selector?
                                  (open-search-select/render-async-select-multi args)
                                  (single-select/render-select dom-atom
                                                               (assoc args
                                                                 :key-atom key-atom
                                                                 :is-multi true))))})))

(defmethod display-string :editor.type/related-entities
  [args]
  (let [selected (:value args)
        options (:options args)]
    (string/join (->> selected
                      (map (fn [s]
                             (->> options
                                  (filter (fn [o] (= (:key o) s)))
                                  (first)
                                  (:label)))))
                 ", ")))

(defmethod viewer :editor.type/related-entities
  [args]
  (r/create-class
   {:display-name   "related-entities/viewer"
    :reagent-render (fn [args]
                      (let [selected (:value args)
                            options (:options args)]
                        [:div.preview.preview-multi-select
                         (doall (for [s selected]
                                  (let [label (->> options
                                                   (filter (fn [o] (= (:key o) s)))
                                                   (first)
                                                   (:label))]
                                    [:a
                                     {:key      s
                                      :href     "#"
                                      :on-click (fn [e]
                                                  (.preventDefault e))}
                                     label])))]))}))
